<template>
  <!-- check status :   หน้าต่างโชว์ต่อเจ้าหน้าที่ และ มี หน้าต่างให้เจ้าหน้าที่ยืนยันรายการชั้น 6 -->
  <div id="Meetingroom">
    <meetingroomStaff />
  </div>
</template>

<script>
import meetingroomStaff from '../../components/staff/meetingroomStaff.vue';
export default {
  components: {meetingroomStaff  },
  name: "MeetingeoomView",

};
</script>

<style scoped>

</style>
